module.exports = __webpack_public_path__ + "static/img/11bg_12.db72385.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_12.png
// module id = 629
// module chunks = 1